import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MasLogo from "./MasLogo";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white mt-28 no-print">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 border-b border-white/10 pb-14">
          <div className="lg:col-span-4">
            <MasLogo tone="light" size="lg" />
            <p className="text-white/55 text-sm max-w-sm leading-relaxed mt-6">
              The new standard in trading card grading. Precision assessment, tamper-evident encapsulation,
              and a transparent population registry — from the team behind MAS Certified, Inc.
            </p>
            <Link to="/submit" className="group inline-flex items-center gap-2 mt-8 px-7 py-3.5 bg-white text-[#0A0A0A] font-bold rounded-full hover:bg-neutral-200 transition-colors duration-300">
              Submit an item <ArrowRight size={16} className="group-hover:translate-x-0.5 transition-transform duration-300" />
            </Link>
          </div>
          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-8">
            {[
              { h: "Card Grading", links: [["Verify a Cert", "/lookup"], ["Submit Cards", "/submit"], ["Turnaround & Pricing", "/submit"], ["Population Report", "/lookup"]] },
              { h: "Company", links: [["Who We Are", "/about"], ["Our Process", "/process"], ["The MAS Standard", "/standard"], ["Newsroom", "/press"], ["Contact Us", "/contact"]] },
              { h: "Resources", links: [["Grading Guide", "/trading-card-grading"], ["Why MAS", "/why-mas"], ["Compare Grading", "/compare"], ["Witnessed Certification", "/witnessed-certification"], ["Grading Scale", "/grading-scale"], ["Card Grades Explained", "/card-grades"], ["MAS Certified, Inc.", "https://mascertified.com"], ["FAQ", "/faq"]] },
              { h: "My Account", links: [["Sign In", "/login"], ["Create Account", "/register"], ["My Submissions", "/portal"], ["Track a Submission", "/portal"]] },
            ].map((col) => (
              <div key={col.h}>
                <h4 className="text-[11px] uppercase tracking-[0.2em] text-white/40 mb-5 font-bold">{col.h}</h4>
                <ul className="space-y-3 text-sm">
                  {col.links.map(([label, to]) => (
                    <li key={label}>
                      {to.startsWith("http")
                        ? <a href={to} target="_blank" rel="noreferrer" className="text-white/70 hover:text-white transition-colors duration-300">{label}</a>
                        : <Link to={to} className="text-white/70 hover:text-white transition-colors duration-300">{label}</Link>}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-wrap justify-between items-center gap-4 pt-8 text-xs text-white/40">
          <span>© {new Date().getFullYear()} MAS Certified, Inc. All Rights Reserved.</span>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-white transition-colors duration-300">Privacy</Link>
            <Link to="/terms" className="hover:text-white transition-colors duration-300">Terms</Link>
            <span className="tracking-[0.15em] uppercase">Authenticity Guaranteed</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
